import { render, staticRenderFns } from "./AfaEsameObiettivo.vue?vue&type=template&id=1f766734"
import script from "./AfaEsameObiettivo.vue?vue&type=script&lang=js"
export * from "./AfaEsameObiettivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports